import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
import { comparison } from '../data/landing';
export function ComparisonSection() {
  return <section className="w-full bg-cream px-4 py-11 sm:px-8 sm:py-16" data-id="element-28" data-mp="3e69aq2wqlww4">
      <div className="mx-auto max-w-5xl" data-id="element-29" data-mp="39dpnee88zne4">
        <h2 className="font-display text-2xl font-extrabold leading-tight text-ink-900 sm:text-4xl" data-id="element-30" data-mp="39cod4bz234xg">
          Menos tiempo buscando. Más tiempo enseñando.
        </h2>

        <div className="mt-5 overflow-hidden rounded-xl border border-cream-300 bg-white shadow-card sm:mt-8 sm:rounded-2xl" data-id="element-31" data-mp="2zi4quvly7fbr">
          <div className="grid grid-cols-2" data-id="element-32" data-mp="2vh2m5z99ib2e">
            <h3 className="border-b border-cream-300 px-3 py-2.5 font-sans text-[10px] font-bold uppercase tracking-[0.12em] text-ink-600 sm:px-7 sm:py-4 sm:text-sm sm:tracking-[0.14em]" data-id="element-33" data-mp="2qf3mazcqdwa7">
              Antes
            </h3>
            <h3 className="border-b border-l border-cream-300 bg-ink-900 px-3 py-2.5 font-sans text-[10px] font-bold uppercase tracking-[0.12em] text-gold-400 sm:px-7 sm:py-4 sm:text-sm sm:tracking-[0.14em]" data-id="element-34" data-mp="oo08603mtzkw">
              Después
            </h3>
          </div>

          {comparison.map(row => <div key={row.sin} className="grid grid-cols-2 border-b border-cream-200 last:border-b-0" data-id="element-35" data-mp="3ei9cu8qvvb2w">
              <p className="flex items-start gap-1.5 px-3 py-2.5 font-sans text-xs leading-snug text-ink-600 sm:gap-2 sm:px-7 sm:py-4 sm:text-base" data-id="element-36" data-mp="35frrrxmysohh">
                <XIcon className="mt-0.5 h-3.5 w-3.5 shrink-0 text-brick sm:h-4 sm:w-4" aria-hidden="true" data-id="element-37" data-mp="3t6491z43nxkq" />
                {row.sin}
              </p>
              <p className="flex items-start gap-1.5 border-l border-cream-200 bg-cream/60 px-3 py-2.5 font-sans text-xs font-semibold leading-snug text-ink-900 sm:gap-2 sm:px-7 sm:py-4 sm:text-base" data-id="element-38" data-mp="3jf9jakrnafuj">
                <CheckIcon className="mt-0.5 h-3.5 w-3.5 shrink-0 text-gold-600 sm:h-4 sm:w-4" aria-hidden="true" data-id="element-39" data-mp="fxre6l39bmxt" />
                {row.con}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}